<template>
  <div class="sign-in">
    <p class="sign-in__eyebrow">Learn to Enjoy Cooking</p>
    <h1 class="sign-in__title">Eight dinners. One new thing each.</h1>
    <p class="sign-in__blurb">
      Sign in with the account you use for Meal Hat. The lessons read what’s
      in your fridge, put what’s missing on your shopping list, and walk you
      through the cooking one step at a time.
    </p>
    <button type="button" class="btn btn-primary btn-lg" :disabled="busy" @click="go">
      {{ busy ? 'Opening Google…' : 'Sign in with Google' }}
    </button>
    <p v-if="error" class="sign-in__error">{{ error }}</p>
  </div>
</template>

<script>
import { ref } from 'vue';
import { signIn } from '../firebase.js';

export default {
  name: 'SignIn',
  setup () {
    const busy = ref(false);
    const error = ref(null);

    async function go () {
      if (busy.value) return;
      busy.value = true;
      error.value = null;
      try {
        await signIn();
      } catch (err) {
        // The one failure worth naming: an origin Firebase has not been told
        // about. Everything else is "try again".
        error.value = err?.code === 'auth/unauthorized-domain'
          ? 'This address isn’t on Meal Hat’s sign-in list yet. Matt has to add it in the Firebase console.'
          : (err?.code === 'auth/popup-closed-by-user' ? null : 'Google didn’t finish signing you in. Try again.');
      } finally {
        busy.value = false;
      }
    }

    return { busy, error, go };
  }
};
</script>

<style scoped>
.sign-in {
  display: flex; flex-direction: column; gap: 1rem; align-items: flex-start;
  max-width: 34rem; margin: 0 auto; padding: 3rem 1.25rem;
}
.sign-in__eyebrow { margin: 0; text-transform: uppercase; letter-spacing: 0.12em; font-size: 0.75rem; color: var(--accent); font-weight: 700; }
.sign-in__title { margin: 0; font-size: 2rem; line-height: 1.15; }
.sign-in__blurb { margin: 0; color: var(--muted); font-size: 1.05rem; }
.sign-in__error { margin: 0; color: var(--danger); }
</style>
